export{MonetateScript}from"./script.js";export{monetate}from"./monetate.js";
//# sourceMappingURL=index.js.map
